import { LoadingOutlined } from '@ant-design/icons';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BOTTOM_BAR_OFFSET, PAGE_HEIGHT } from '../constants';
import { useCurrentUser } from '../context/UserContext';

const styles = {
  main: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: PAGE_HEIGHT,
    padding: `20px 22px ${BOTTOM_BAR_OFFSET}`,
  },
  button: {
    marginTop: '24px',
  },
  intro: {
    marginTop: '16px',
  },
}

export default function Home() {
  const navigate = useNavigate();
  const { user, loading } = useCurrentUser();

  function onEditClick() {
    navigate(`/user/${user._id}/details/edit`);
  }

  let content = (
    <Box sx={styles.main}>
      <Button
        key="Sign-Up"
        variant="contained"
        disableElevation
        color="primary"
        sx={styles.button}
        onClick={() => navigate('/signup')}
      >
        Sign-Up
      </Button>
      <Button
        key="Login"
        variant="contained"
        disableElevation
        color="secondary"
        sx={styles.button}
        onClick={() => navigate('/login')}
      >
        Login
      </Button>
    </Box>
  );

  if (loading) {
    content = <LoadingOutlined />;
  } else if (user && !user.handle) {
    content = (
      <Box sx={styles.main}>
        <Typography color="primary" variant="h2" align="center">
          Welcome to amplo!
        </Typography>
        <Typography
          color="primary"
          variant="h5"
          align="center"
          sx={styles.intro}
        >
          To get the most out of amplo, complete your profile and add a
          username.
        </Typography>
        <Button
          sx={styles.button}
          variant="contained"
          color="primary"
          disableElevation
          aria-label="Edit my Profile"
          fullWidth
          onClick={onEditClick}
        >
          Edit my Profile
        </Button>
      </Box>
    );
  } else if (user) {
    content = (
      <Box sx={styles.main}>
        <Typography color="primary" variant="h2" align="center">
          Welcome back, {user.firstName}!
        </Typography>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Button
            variant="contained"
            color="primary"
            sx={styles.button}
            onClick={() => navigate(`/user/${user._id}/groups`)}
            disableElevation
            aria-label="go to Groups"
          >
            Groups
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={styles.button}
            onClick={() => navigate('/events')}
            disableElevation
            aria-label="go to Events"
          >
            Events
          </Button>
        </Box>
      </Box>
    );
  }
  return content;
}
